import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProgramComponent} from './program.component';
import {CounselingComponent} from './counseling/counseling.component';

const routes: Routes = [
    {path: 'program', component: ProgramComponent},
    {path: 'counseling', component: CounselingComponent}
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProgramRoutingModule {
}
